
import CreativeLib from '../../components/creativeLib.vue';

export default {
  components: {
    CreativeLib: CreativeLib
  },
  props: {
    resourceClass: {
      type: Number,
      default: 2 // 1代表交互类型素材，2代表非交互类型素材
    }
  }
};